var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading"},[_c('p',[_vm._v(_vm._s(_vm.texto))]),_c('div',{staticClass:"dot-flashing"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }